export default "__VITE_ASSET__DKwAnFzB__"